<script lang="ts">
  import { Accordion, Text } from '@squareup/public-web-design-system';
  import DynamicChildrenComponent from '$lib/components/DynamicChildrenComponent/DynamicChildrenComponent.svelte';
  import type { PwNextFaqProps } from './types';

  const { entryId, customCssClass, heading, firstItemOpen, faqItems }: PwNextFaqProps = $props();

  function handleClick(index: number): void {
    window.Sq.Tracking.track(
      {
        action: 'Content Explorer',
        properties: {
          question: faqItems[index].question,
        },
      },
      {
        destinations: ['cdp'],
      }
    );
  }
</script>

<div class="PwNextFaq PwNextFaq-{entryId}-box-properties {customCssClass}" data-entry-id={entryId}>
  {#if heading}
    <div class="PwNextFaq__heading">
      <Text variant="700" as="h2">{heading}</Text>
    </div>
  {/if}

  <Accordion isFirstItemOpenByDefault={firstItemOpen} items={faqItems} onClick={(index) => handleClick(index)}>
    {#snippet summary({ question })}
      <Text as="h3" variant="200" isBalanced={true}>
        {question}
      </Text>
    {/snippet}
    {#snippet content({ answer })}
      <DynamicChildrenComponent children={[answer]} />
    {/snippet}
  </Accordion>
</div>

<style lang="scss">
  @use '@squareup/public-web-design-system/dist/tokens/generated-tokens/scss/_media_queries' as mediaQueries;

  @layer custom-components {
    .PwNextFaq {
      &__heading {
        margin-bottom: var(--space-40);

        @include mediaQueries.at('large') {
          margin-bottom: var(--space-80);
        }
      }

      // PwNextFaq will be deprecated when all of the pages switch over to PWDS's Faq
      // This styling is copied and pasted from the Faq module since Accordion and AccordionItem has been decoupled from
      // Faq
      :global {
        .AccordionItem__content {
          max-width: 70ch;
          // This needs to be padding because margin is not measured in offsetHeight
          padding-bottom: var(--space-30);

          @include mediaQueries.at('medium') {
            padding-bottom: var(--space-40);
          }

          // Override styling that applies to .RichTextFieldComponent p since max-width is set on the parent element
          p {
            --max-width: none;
          }

          // Override styling that applies to main a since font-weight is regular instead of medium
          a:not(.Action) {
            font-weight: var(--text-font-weight-regular);
          }
        }
      }
    }
  }
</style>
